/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { localDate } from "../../utils/helpers/date";
import { queryKeys } from "./queryKeys";

export const useSchedule = (params, queryParams) => {
  return useQuery({
    queryKey: queryKeys.schedule.list(params),
    queryFn: () => fetcher({ method: "GET", url: "/public/timeline/schedule", params }),
    select: (data) =>
      data?.map((day) => ({
        ...day,
        date: localDate(day.date),
      })),
    ...queryParams,
  });
};
